// Test Mode
export const TopUpPlansDataLocal = {
  words_and_credits: [
    {
      name: 'Tier 1',
      full_name: 'TopUp WC Tier 1',
      value: 100000,
      label: '100,000 words + 1000 credits - $100',
      payment_link: 'https://buy.stripe.com/test_4gweVZdrl2e5c36bJb',
      payment_link_id: 'plink_1R6P7TI7nKZV6RR2glA7id3c',
    },
    {
      name: 'Tier 2',
      full_name: 'TopUp WC Tier 2',
      value: 200000,
      label: '200,000 words + 2000 credits - $150',
      payment_link: 'https://buy.stripe.com/test_bIY3dhcnh1a1c36dRk',
      payment_link_id: 'plink_1R6PBQI7nKZV6RR2TV7EC55C',
    },
    {
      name: 'Tier 3',
      full_name: 'TopUp WC Tier 3',
      value: 300000,
      label: '300,000 words + 3000 credits - $200',
      payment_link: 'https://buy.stripe.com/test_6oE3dh0EzbOF5EI3cH',
      payment_link_id: 'plink_1R6PCKI7nKZV6RR2Leq7Wurz',
    },
    {
      name: 'Tier 4',
      full_name: 'TopUp WC Tier 4',
      value: 400000,
      label: '400,000 words + 4000 credits - $250',
      payment_link: 'https://buy.stripe.com/test_bIYdRV871cSJ1os7sY',
      payment_link_id: 'plink_1R6PCxI7nKZV6RR2oiPidHMm',
    },
    {
      name: 'Tier 5',
      full_name: 'TopUp WC Tier 5',
      value: 500000,
      label: '500,000 words + 5000 credits - $300',
      payment_link: 'https://buy.stripe.com/test_eVa4hlbjd8Ct3wA4gN',
      payment_link_id: 'plink_1R6PGuI7nKZV6RR2UwBheATz',
    },
    {
      name: 'Tier 6',
      full_name: 'TopUp WC Tier 6',
      value: 600000,
      label: '600,000 words + 6000 credits - $350',
      payment_link: 'https://buy.stripe.com/test_cN2bJN9b5g4V3wA6oW',
      payment_link_id: 'plink_1R6PINI7nKZV6RR2bojHhGR5',
    },
    {
      name: 'Tier 7',
      full_name: 'TopUp WC Tier 7',
      value: 700000,
      label: '700,000 words + 7000 credits - $400',
      payment_link: 'https://buy.stripe.com/test_9AQbJN72X2e5c36bJh',
      payment_link_id: 'plink_1R6PJBI7nKZV6RR26PgsIPKN',
    },
    {
      name: 'Tier 8',
      full_name: 'TopUp WC Tier 8',
      value: 800000,
      label: '800,000 words + 8000 credits - $450',
      payment_link: 'https://buy.stripe.com/test_9AQeVZgDxaKB7MQaFe',
      payment_link_id: 'plink_1R6PJsI7nKZV6RR2r5htt0Fc',
    },
    {
      name: 'Tier 9',
      full_name: 'TopUp WC Tier 9',
      value: 900000,
      label: '900,000 words + 9000 credits - $500',
      payment_link: 'https://buy.stripe.com/test_9AQ6pt8717yp0ko28J',
      payment_link_id: 'plink_1R6PKvI7nKZV6RR2WinFm2MN',
    },
    {
      name: 'Tier 10',
      full_name: 'TopUp WC Tier 10',
      value: 1000000,
      label: '1,000,000 words + 10,000 credits - $550',
      payment_link: 'https://buy.stripe.com/test_4gw7tx5YTcSJaZ228K',
      payment_link_id: 'plink_1R6PLjI7nKZV6RR2oTsMBV33',
    },
  ],
  images: [
    {
      name: 'Tier 1',
      full_name: 'TopUp IMG Tier 1',
      value: 100,
      label: '100 images - $30',
      payment_link: 'https://buy.stripe.com/test_fZe29d9b56ul8QU8wL',
      payment_link_id: 'plink_1QP2eDI7nKZV6RR2AWUbxpFi',
    },
    {
      name: 'Tier 2',
      full_name: 'TopUp IMG Tier 2',
      value: 200,
      label: '200 images - $60',
      payment_link: 'https://buy.stripe.com/test_eVa29dfztcSJd7a00g',
      payment_link_id: 'plink_1QP2eyI7nKZV6RR2K5Ms9JRI',
    },
    {
      name: 'Tier 3',
      full_name: 'TopUp IMG Tier 3',
      value: 300,
      label: '300 images - $90',
      payment_link: 'https://buy.stripe.com/test_eVa3dhcnhf0R8QU00h',
      payment_link_id: 'plink_1QP2fhI7nKZV6RR2nlu1pQxg',
    },
    {
      name: 'Tier 4',
      full_name: 'TopUp IMG Tier 4',
      value: 400,
      label: '400 images - $120',
      payment_link: 'https://buy.stripe.com/test_3cs3dh871cSJ0koaEW',
      payment_link_id: 'plink_1QP2gOI7nKZV6RR2GAx12UQC',
    },
    {
      name: 'Tier 5',
      full_name: 'TopUp IMG Tier 5',
      value: 500,
      label: '500 images - $150',
      payment_link: 'https://buy.stripe.com/test_28oeVZ3QLcSJffi14n',
      payment_link_id: 'plink_1QP2gnI7nKZV6RR2S5HuJI7c',
    },
    {
      name: 'Tier 6',
      full_name: 'TopUp IMG Tier 6',
      value: 600,
      label: '600 images - $180',
      payment_link: 'https://buy.stripe.com/test_eVabJN2MHg4V2swcN6',
      payment_link_id: 'plink_1QP2hJI7nKZV6RR2tcMWJIGR',
    },
    {
      name: 'Tier 7',
      full_name: 'TopUp IMG Tier 7',
      value: 700,
      label: '700 images - $210',
      payment_link: 'https://buy.stripe.com/test_eVa8xB2MH5qh3wAbJ3',
      payment_link_id: 'plink_1QP2hrI7nKZV6RR25FXiUgKD',
    },
    {
      name: 'Tier 8',
      full_name: 'TopUp IMG Tier 8',
      value: 800,
      label: '800 images - $240',
      payment_link: 'https://buy.stripe.com/test_6oE3dhevp6uld7adRc',
      payment_link_id: 'plink_1QP2iMI7nKZV6RR2KOOwREcW',
    },
    {
      name: 'Tier 9',
      full_name: 'TopUp IMG Tier 9',
      value: 900,
      label: '900 images - $270',
      payment_link: 'https://buy.stripe.com/test_cN2bJNdrlf0RffieVh',
      payment_link_id: 'plink_1QP2jNI7nKZV6RR2bWDsRvar',
    },
    {
      name: 'Tier 10',
      full_name: 'TopUp IMG Tier 10',
      value: 1000,
      label: '1000 images - $300',
      payment_link: 'https://buy.stripe.com/test_8wMdRVaf96ul8QUbJ6',
      payment_link_id: 'plink_1QP2kBI7nKZV6RR2mimXxfSd',
    },
  ],
}

//Live Mode
export const TopUpPlansDataProduction = {
  words_and_credits: [
    {
      name: 'Tier 1',
      full_name: 'TopUp WC Tier 1',
      value: 100000,
      label: '100,000 words + 1000 credits - $100',
      payment_link: 'https://buy.stripe.com/28o5kQ40dfRc6mQ6p0',
      payment_link_id: 'plink_1R6RNDI7nKZV6RR2O2BsZJdg',
    },
    {
      name: 'Tier 2',
      full_name: 'TopUp WC Tier 2',
      value: 200000,
      label: '200,000 words + 2000 credits - $150',
      payment_link: 'https://buy.stripe.com/28oeVq8gtcF0h1u7t3',
      payment_link_id: 'plink_1R6RN2I7nKZV6RR2xxAeF1Rv',
    },
    {
      name: 'Tier 3',
      full_name: 'TopUp WC Tier 3',
      value: 300000,
      label: '300,000 words + 3000 credits - $200',
      payment_link: 'https://buy.stripe.com/28o14A1S57kG3aE7t2',
      payment_link_id: 'plink_1R6RN1I7nKZV6RR2tb3p0QiV',
    },
    {
      name: 'Tier 4',
      full_name: 'TopUp WC Tier 4',
      value: 400000,
      label: '400,000 words + 4000 credits - $250',
      payment_link: 'https://buy.stripe.com/dR6cNi68l7kG5iM3cL',
      payment_link_id: 'plink_1R6RMzI7nKZV6RR2BFjaEOCf',
    },
    {
      name: 'Tier 5',
      full_name: 'TopUp WC Tier 5',
      value: 500000,
      label: '500,000 words + 5000 credits - $300',
      payment_link: 'https://buy.stripe.com/bIYaFa8gtawScLe9B8',
      payment_link_id: 'plink_1R6RMxI7nKZV6RR2B5Q1n0kB',
    },
    {
      name: 'Tier 6',
      full_name: 'TopUp WC Tier 6',
      value: 600000,
      label: '600,000 words + 6000 credits - $350',
      payment_link: 'https://buy.stripe.com/14k6oUgMZbAWfXq28F',
      payment_link_id: 'plink_1R6RMvI7nKZV6RR2Q2DTusxq',
    },
    {
      name: 'Tier 7',
      full_name: 'TopUp WC Tier 7',
      value: 700000,
      label: '700,000 words + 7000 credits - $400',
      payment_link: 'https://buy.stripe.com/bIYaFa40d5cy4eI4gM',
      payment_link_id: 'plink_1R6RMtI7nKZV6RR20bmvH8B7',
    },
    {
      name: 'Tier 8',
      full_name: 'TopUp WC Tier 8',
      value: 800000,
      label: '800,000 words + 8000 credits - $450',
      payment_link: 'https://buy.stripe.com/28ofZu54h9sO5iMaF9',
      payment_link_id: 'plink_1R6RMpI7nKZV6RR2zgAZRLme',
    },
    {
      name: 'Tier 9',
      full_name: 'TopUp WC Tier 9',
      value: 900000,
      label: '900,000 words + 9000 credits - $500',
      payment_link: 'https://buy.stripe.com/5kA9B6gMZawS5iMbJc',
      payment_link_id: 'plink_1R6RMmI7nKZV6RR2AnVXpdnQ',
    },
    {
      name: 'Tier 10',
      full_name: 'TopUp WC Tier 10',
      value: 1000000,
      label: '1,000,000 words + 10,000 credits - $550',
      payment_link: 'https://buy.stripe.com/bIY5kQ8gtgVg6mQbJb',
      payment_link_id: 'plink_1R6RMjI7nKZV6RR2zsSi1eBN',
    },
  ],
  images: [
    {
      name: 'Tier 1',
      full_name: 'TopUp IMG Tier 1',
      value: 100,
      label: '100 images - $30',
      payment_link: 'https://buy.stripe.com/28o5kQ0O16gCfXq006',
      payment_link_id: 'plink_1Qc1H5I7nKZV6RR271W5cePS',
    },
    {
      name: 'Tier 2',
      full_name: 'TopUp IMG Tier 2',
      value: 200,
      label: '200 images - $60',
      payment_link: 'https://buy.stripe.com/cN26oU0O120meTm4gn',
      payment_link_id: 'plink_1Qc1LYI7nKZV6RR2tLIA7Qrq',
    },
    {
      name: 'Tier 3',
      full_name: 'TopUp IMG Tier 3',
      value: 300,
      label: '300 images - $90',
      payment_link: 'https://buy.stripe.com/fZe6oUcwJ7kG7qUcMU',
      payment_link_id: 'plink_1Qc1LfI7nKZV6RR2xLx81g9d',
    },
    {
      name: 'Tier 4',
      full_name: 'TopUp IMG Tier 4',
      value: 400,
      label: '400 images - $120',
      payment_link: 'https://buy.stripe.com/aEU14A0O120mcLe9AJ',
      payment_link_id: 'plink_1Qc1LdI7nKZV6RR2KMns61zw',
    },
    {
      name: 'Tier 5',
      full_name: 'TopUp IMG Tier 5',
      value: 500,
      label: '500 images - $150',
      payment_link: 'https://buy.stripe.com/aEUeVqdAN34q7qUeV4',
      payment_link_id: 'plink_1Qc1LiI7nKZV6RR2CVezVA5T',
    },
    {
      name: 'Tier 6',
      full_name: 'TopUp IMG Tier 6',
      value: 600,
      label: '600 images - $180',
      payment_link: 'https://buy.stripe.com/14kbJeaoBdJ4cLeaEP',
      payment_link_id: 'plink_1Qc1LkI7nKZV6RR2evHYxcXW',
    },
    {
      name: 'Tier 7',
      full_name: 'TopUp IMG Tier 7',
      value: 700,
      label: '700 images - $210',
      payment_link: 'https://buy.stripe.com/9AQbJegMZcF09z28wI',
      payment_link_id: 'plink_1Qc1LlI7nKZV6RR2BS3e6uWI',
    },
    {
      name: 'Tier 8',
      full_name: 'TopUp IMG Tier 8',
      value: 800,
      label: '800 images - $240',
      payment_link: 'https://buy.stripe.com/eVabJedANgVgcLe28l',
      payment_link_id: 'plink_1Qc1LnI7nKZV6RR24CAGihnC',
    },
    {
      name: 'Tier 9',
      full_name: 'TopUp IMG Tier 9',
      value: 900,
      label: '900 images - $270',
      payment_link: 'https://buy.stripe.com/8wM4gMcwJ20mbHa7sG',
      payment_link_id: 'plink_1Qc1LpI7nKZV6RR2gNlzY3E6',
    },
    {
      name: 'Tier 10',
      full_name: 'TopUp IMG Tier 10',
      value: 1000,
      label: '1000 images - $300',
      payment_link: 'https://buy.stripe.com/3cs5kQeER20m7qUdR5',
      payment_link_id: 'plink_1Qc1LrI7nKZV6RR2QDSrUVh1',
    },
  ],
}
